import request from '@/utils/request'

// 查询历史搜索列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/search/history/page',
        method: 'get',
        params: query,
    })
}
// 查询历史搜索详细
export function getObj(id) {
    return request({
        url: '/upkeep/search/history/detail?id=' + id,
        method: 'get',
    })
}
// 新增历史搜索
export function addObj(data) {
    return request({
        url: '/upkeep/search/history/add',
        method: 'post',
        data: data,
    })
}
// 修改历史搜索
export function putObj(data) {
    return request({
        url: '/search/history/edit',
        method: 'post',
        data: data,
    })
}
// 删除历史搜索
export function delObj(data) {
    return request({
        url: '/upkeep/search/history/delete',
        method: 'post',
        data: data,
    })
}
